<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.controlDoctors', 1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form  @reset="onReset" v-if="show">
                    <div class=" " :class="[ mobileView ? '': 'container']">

                        <b-row>

                            <div class="form-group col-md-12">
                                <span class="obligatoire">*</span>
                                <label for="institution" class="typo__label">{{ $tc('message.institutions',1) }}</label>
                                <multiselect v-model="form.etablissements" id="institution" label="name" track-by="id" placeholder="Rechercher un établissement" :options="liste_etablissements" :multiple="true" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getEtablisssements">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="form.etablissements.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                    </template><span slot="noResult">Rechercher un établissement</span>
                                </multiselect>
                                <small id="emailHelp" class="form-text text-danger">{{ errors.has('plaintes') ? "Les plaintes sont requises" : "" }}</small> 
                            </div>

                            <!-- <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="institution-group"
                                        :label="$tc('message.institutions',1)"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.etablissements.$model"
                                            @change="clearErrorField('etablissements')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                            multiple
                                    >
                                        <option data-placeholder="true"></option>
                                        <option value="0">
                                            {{ $t('message.addAll') | capitalize}}
                                        </option>
                                        <option v-for="item in mInstitutions" :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.etablissements.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissements')" style="color:red">
                                    {{getErrorsField('etablissements')}}
                                    </span>
                                </b-form-group>
                            </b-col> -->
                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.firstName')"
                                        label-for="prenom"
                                >
                                    <b-form-input
                                            id="prenom"
                                            v-model="$v.form.prenom.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="indicatif-group"
                                        :label="$t('message.indicatif')"
                                        label-for="indicatif"
                                >
                                    <b-form-input
                                            id="indicatif"
                                            v-model="$v.form.indicatif.$model"
                                            :state="$v.form.indicatif.$dirty ? !($v.form.indicatif.$error) : null"
                                            required
                                            placeholder=""
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.numeric">
                                        {{ $t('message.integer', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.maxLength">
                                        {{ $t('message.maxCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone">
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group id="specialite-group" :label="$t('message.select')+' '+$tc('message.specialties', 1)" label-for="specialite">
                                    <multiselect v-model="form.specialite" :options="mSpecialties"  :placeholder="$t('message.select')+' '+$tc('message.specialties', 1)" label="text" track-by="value"></multiselect>
                                    <b-form-invalid-feedback v-if="$v.form.specialite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('specialite_id')">
                                        {{ getErrorsField('specialite_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="numero-group"
                                        :label="$t('message.orderNumber')"
                                        label-for="numero"
                                >
                                    <b-form-input
                                            id="numero"
                                            v-model="$v.form.numero.$model"
                                            :state="$v.form.numero.$dirty ? !(errorshasField('numero_ordre') || $v.form.numero.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('numero_ordre')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('numero_ordre')">
                                        {{ getErrorsField('numero_ordre') }}
                                    </b-form-invalid-feedback>

                                    <!--                                    <b-form-invalid-feedback v-if="!$v.form.numero.required">-->
                                    <!--                                        {{ $t('message.requiredField') }}-->
                                    <!--                                    </b-form-invalid-feedback>-->

                                    <b-form-invalid-feedback v-if="!$v.form.numero.minLength">
                                        {{ $t('message.minCharacters', { n: 4 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.numero.integer">
                                        {{ $t('message.integer', { n: 4 }) }}
                                    </b-form-invalid-feedback>


                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="civilite-group"
                                        :label="$t('message.select')+' '+$t('message.civility')"
                                        label-for="civilite">
                                    <!-- Options -->
                                    <multiselect v-model="form.civilite" :options="civilites"  :placeholder="$t('message.select')+' '+$tc('message.civility', 1)" label="text" track-by="value"></multiselect>
                                    <b-form-invalid-feedback v-if="$v.form.civilite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('civilite')">
                                        {{ getErrorsField('civilite') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="$v.form.nationalite.$model"
                                            :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.nationalite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singleAddDoctor-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singleAddDoctor">
                                    <!-- Options -->
                                    <multiselect v-model="form.pays" :options="mCountries"  :placeholder="$t('message.select')+' '+$tc('message.countries', 1)" label="text" track-by="value"></multiselect>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="$v.form.ville.$model"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="$v.form.quartier.$model"
                                            :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="$v.form.code_postal.$model"
                                            :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="$v.form.adresse.$model"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

                                    <!--                                    <b-form-invalid-feedback v-if="!$v.form.adresse.required">-->
                                    <!--                                        {{ $t('message.requiredField') }}-->
                                    <!--                                    </b-form-invalid-feedback>-->
                                </b-form-group>

                            </b-col>
                            <b-col sm="4">

                                <b-form-group
                                        id="slack-group"
                                        :label="$t('message.slack')"
                                        label-for="slack"
                                >
                                    <b-form-input
                                            id="slack"
                                            v-model="$v.form.slack.$model"
                                            :state="$v.form.slack.$dirty ? !(errorshasField('slack') || $v.form.slack.$error) : null"
                                            @focus="clearErrorField('slack')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('slack')">
                                        {{ getErrorsField('slack') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc" type="checkbox" v-model="isMedicasure"/>
                                        <label for="hasDesc">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>

                            <b-col sm="3" v-if="userIsMed">
                                <div>
                                    <label class="form__label" for="hasDesc2">{{$t('message.userIsNotice')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="isNotice"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadFile')"
                                        label-for="upload"
                                >
                                    <b-form-file
                                            id="upload"
                                            :state="$v.form.signature.$dirty ? !$v.form.signature.$error : null"
                                            :placeholder="$t('message.uploadFile')"
                                            :file-name-formatter="formatNames"
                                            @change="setImage"
                                    ></b-form-file>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <!--                            <b-col sm="6">-->
                            <!--                                <b-container fluid class="p-4">-->
                            <!--                                    <b-row id="image">-->
                            <!--                                        <b-col>-->
                            <!--                                            <b-img-lazy-->
                            <!--                                                    class="img-preview"-->
                            <!--                                                    thumbnail-->
                            <!--                                                    :src="imageSrc(form.signature)"-->
                            <!--                                                    fluid-grow-->
                            <!--                                                    alt=""-->
                            <!--                                            ></b-img-lazy>-->
                            <!--                                        </b-col>-->
                            <!--                                    </b-row>-->
                            <!--                                </b-container>-->
                            <!--                            </b-col>-->

                        </b-row>

                    </div>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {required, email, minLength, integer, maxLength, numeric} from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import AppConfig from '../../constants/AppConfig';
    import Multiselect from 'vue-multiselect';
    
    export default {
        name: "AddControlDoctor",
         components: {
            Multiselect
        },
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString().toUpperCase();
                return value;
            }
        },
        computed: {
            ...mapGetters(["specialties", "countries", "errors",'hasAdminRole', 'hasAssistante',
                'hasGestionnaireRole']),
            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            mSpecialties: function() {
                let sArray = [];

                _.forOwn(this.specialties, function(value, key) {
                    sArray.push({ text: value.name, value: value.id });
                });

                return sArray;
            }
        },

        data() {
            return {
                isMedicasure: false,
                isNotice: true,
                mobileView: true,
                liste_etablissements: [],
                loading: false,
                form: {
                    nom: '',
                    prenom: '',
                    specialite: null,
                    telephone: '',
                    indicatif: '',
                    numero: '',
                    email: '',
                    civilite: '',
                    nationalite: '',
                    ville: '',
                    pays: '',
                    adresse: '',
                    signature:'',
                    quartier:'',
                    code_postal:'',
                    slack:'',
                    etablissements: [],

                },
                civilites: [
                    { value: 'Mme/Mlle.', text: 'Mme/Mlle.' },
                    { value: 'M.', text: 'M.' },
                    { value: 'Dr.', text: 'Dr.' },
                    { value: 'Pr.', text: 'Pr.' }
                ],
                show: true
            }
        },

        methods: {
            formatNames(files) {
                return files[0].name
            },
            handleView() {
            this.mobileView = window.innerWidth < 991;
            },
            setImage(event) {
                this.form.signature = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    return URL.createObjectURL(img);
                }

                return '';
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getEtablisssements(etablissement){
                this.loading = true;
                fetch(AppConfig.apiUrl+`/findEtablissement/${etablissement}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.liste_etablissements = res.etablissements.map(item => ({id: item.id, name: item.name}));
                }).catch(error => {
                    console.log('error ', error);
                })
            },

            getSpecialties: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSpecialties', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {

                    let formData = new FormData();

                    formData.append('nom', this.form.nom);
                    formData.append('prenom', this.form.prenom);
                    formData.append('specialite_id', this.form.specialite.value);
                    formData.append('email', this.form.email);
                    formData.append('telephone', this.form.indicatif+this.form.telephone);
                    formData.append('numero_ordre', this.form.numero);
                    formData.append('civilite', this.form.civilite.value);
                    formData.append('nationalite', this.form.nationalite);
                    formData.append('ville', this.form.ville);
                    formData.append('adresse', this.form.adresse);
                    formData.append('pays', this.form.pays.value);
                    formData.append('quartier', this.form.quartier);
                    formData.append('slack', this.form.slack);
                    formData.append('code_postal', this.form.code_postal);
                    formData.append('signature', this.form.signature);
                    formData.append('etablissements', this.form.etablissements.map(item => item.id));
                    formData.append('isMedicasure', this.isMedicasure ? '1':'0');
                    formData.append('isNotice', this.isNotice ? '1':'0');


                    let successMessage = this.$i18n.t('message.controlDoctorCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createControlDoctor', { args:formData, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.specialite = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.numero = '';
                this.form.civilite = '';
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';
                this.form.adresse = '';
                this.form.slack = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                etablissements:{
                    required
                },
                nom: {
                    required
                },
                prenom: {
                    //
                },
                specialite: {
                    required
                },
                telephone: {
                    required,
                    integer,
                    minLength: minLength(9)
                },

                indicatif: {
                    required,
                    maxLength: maxLength(3),
                    numeric
                },

                numero: {
                    // required,
                    // integer,
                    // minLength: minLength(4)
                },
                email: {
                    required,
                    email
                },
                civilite: {
                    required
                },
                nationalite: {
                    required
                },
                ville: {
                    required
                },
                quartier: {
                    //
                },
                code_postal: {
                    //
                },
                pays: {
                    required
                },
                adresse: {
                    // required
                },
                slack: {
                    // required
                },
                signature:{

                }
            }
        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },
        mounted() {
            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of specialties
            this.getSpecialties();
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>